const empty = {};
export const getSFULinks = (state) => {
	return state.Filters.fetchStrapiSFU?.data?.links || empty;
};

